import { render } from "./UsersTms.vue?vue&type=template&id=0062827b"
import script from "./UsersTms.vue?vue&type=script&lang=js"
export * from "./UsersTms.vue?vue&type=script&lang=js"

import exportComponent from "D:\\bkp\\my-vue-pwa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__